var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80425 1.5C12.8317 1.5 16.1078 4.776 16.1078 8.8035C16.1078 10.7037 15.3785 12.4367 14.1852 13.7374L16.5333 16.0805C16.7531 16.3003 16.7538 16.6558 16.534 16.8755C16.4246 16.9865 16.2798 17.0413 16.1358 17.0413C15.9925 17.0413 15.8485 16.9865 15.7383 16.877L13.3619 14.5073C12.1118 15.5084 10.5268 16.1077 8.80425 16.1077C4.77675 16.1077 1.5 12.831 1.5 8.8035C1.5 4.776 4.77675 1.5 8.80425 1.5ZM8.80425 2.625C5.397 2.625 2.625 5.39625 2.625 8.8035C2.625 12.2108 5.397 14.9827 8.80425 14.9827C12.2108 14.9827 14.9828 12.2108 14.9828 8.8035C14.9828 5.39625 12.2108 2.625 8.80425 2.625Z",
    fill: "#999999"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdSearch);
export default __webpack_public_path__ + "static/media/ord_search.22c4b85a80142c807e3abd66e8e0b2b4.svg";
export { ForwardRef as ReactComponent };